import { render } from "./KanBanModal.vue?vue&type=template&id=7bf0d0d7&scoped=true"
import script from "./KanBanModal.vue?vue&type=script&lang=js"
export * from "./KanBanModal.vue?vue&type=script&lang=js"

import "./KanBanModal.vue?vue&type=style&index=0&id=7bf0d0d7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf0d0d7"]])

export default __exports__